var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7028 9.68343C13.7278 9.68343 15.3695 8.04181 15.3695 6.01676C15.3695 3.99172 13.7278 2.3501 11.7028 2.3501C9.67776 2.3501 8.03613 3.99172 8.03613 6.01676C8.03613 8.04181 9.67776 9.68343 11.7028 9.68343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2031 14.9541C16.0641 14.9541 15.1406 15.8776 15.1406 17.0166C15.1406 17.335 15.2128 17.6365 15.3417 17.9058L18.0924 15.1551C17.8231 15.0262 17.5216 14.9541 17.2031 14.9541ZM19.0646 16.1273L16.3139 18.8781C16.5831 19.007 16.8847 19.0791 17.2031 19.0791C18.3422 19.0791 19.2656 18.1557 19.2656 17.0166C19.2656 16.6982 19.1935 16.3967 19.0646 16.1273ZM13.7656 17.0166C13.7656 15.1181 15.3046 13.5791 17.2031 13.5791C19.1016 13.5791 20.6406 15.1181 20.6406 17.0166C20.6406 18.9151 19.1016 20.4541 17.2031 20.4541C15.3046 20.4541 13.7656 18.9151 13.7656 17.0166Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7523 12.8738C13.3382 13.712 12.3903 15.2536 12.3903 17.0165C12.3903 17.9967 12.6834 18.9084 13.1866 19.6689C12.7103 19.7333 12.2136 19.7674 11.7028 19.7674C8.15898 19.7674 5.28613 18.1258 5.28613 16.1007C5.28613 14.0756 8.15898 12.4341 11.7028 12.4341C12.8066 12.4341 13.8452 12.5933 14.7523 12.8738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockUserIcon);
export default __webpack_public_path__ + "static/media/BlockUserIcon.f5e5426f3fffe673d0d69f6484402ec3.svg";
export { ForwardRef as ReactComponent };